import React from 'react';
import { FiCopy, FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import { RECOMMEND_SEARCH_WORD_TYPE_TEXT } from '../../../../../constants/service/app/recommendSearchWordConstants';
import {
  RECOMMEND_SEARCH_WORD_COPY_URL_PATH,
  RECOMMEND_SEARCH_WORD_DETAIL_URL_PATH,
} from '../../../../../constants/service/common/urlConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { openNewWindow, reDirectPage, setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import Anchor from '../../../../../components/link/Anchor';

/**
 *  추천 검색 키워드 리스트 컬림
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'상세보기'} />,
      dataIndex: 'detail',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(RECOMMEND_SEARCH_WORD_DETAIL_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'복사하기'} />,
      dataIndex: 'copy',
      render: (value, record) => (
        <FiCopy
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(RECOMMEND_SEARCH_WORD_COPY_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'추천 검색 키워드 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          isUnderLine
          color="primary"
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(RECOMMEND_SEARCH_WORD_DETAIL_URL_PATH, value))}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'추천인'} />,
      dataIndex: 'adminName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'추천 타입'} />,
      dataIndex: 'type',
      render: (value) => RECOMMEND_SEARCH_WORD_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'메모'} />,
      dataIndex: 'memo',
    },
  ];
};
